// extracted by mini-css-extract-plugin
module.exports = {"isEditable":"editCardBtn_isEditable__3UgXi"};
    if(module.hot) {
      // 1790670299075
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  